"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityCriteriaFrequencyConst = exports.EntityTokenRecordTypeConst = exports.QuestRewardTypeConst = exports.EligibilityCriteriaSource = exports.EligibilityCriteriaTypeConst = exports.EligibilityCriteriaImportanceConst = exports.EligibilityCriteriaEffortConst = exports.USER_AGENT = exports.HTTP_METHOD = void 0;
exports.HTTP_METHOD = {
    GET: "GET",
    POST: "POST",
    PATCH: "PATCH",
    DELETE: "DELETE",
};
exports.USER_AGENT = {
    MOBILE: "MOBILE",
    BROWSER: "BROWSER",
    SERVER: "SERVER",
};
exports.EligibilityCriteriaEffortConst = {
    /**
     * Less than 1 min
     */
    E1: "E1",
    /**
     * 1 - 5 mins
     */
    E2: "E2",
    /**
     * 5 - 10 mins
     */
    E3: "E3",
    /**
     * 10 - 30 mins
     */
    E4: "E4",
    /**
     * 30 - 60 mins
     */
    E5: "E5",
};
exports.EligibilityCriteriaImportanceConst = {
    /**
     * Low importance
     */
    I1: "I1",
    /**
     * Moderate importance
     */
    I2: "I2",
    /**
     * Medium importance
     */
    I3: "I3",
    /**
     * High importance
     */
    I4: "I4",
    /**
     * Super importance
     */
    I5: "I5",
};
exports.EligibilityCriteriaTypeConst = {
    NONE: "NONE",
    TWITTER_FOLLOW_ACCOUNT: "TWITTER_FOLLOW_ACCOUNT",
    TWITTER_LIKE_POST: "TWITTER_LIKE_POST",
    TWITTER_COMMENT_POST: "TWITTER_COMMENT_POST",
    TWITTER_RETWEET_POST: "TWITTER_RETWEET_POST",
    TWITTER_JOIN_SPACE: "TWITTER_JOIN_SPACE",
    DISCORD_JOIN_GUILD: "DISCORD_JOIN_GUILD",
    DISCORD_ASSIGNED_ROLE: "DISCORD_ASSIGNED_ROLE",
    LINK_OPEN_READ: "LINK_OPEN_READ",
    CONTRACT_MIN_OWNERSHIP: "CONTRACT_MIN_OWNERSHIP",
    DAPP_METRIC_THRESHOLD: "DAPP_METRIC_THRESHOLD",
    DAPP_STREAK_THRESHOLD: "DAPP_STREAK_THRESHOLD",
    USER_INPUT_TEXT: "USER_INPUT_TEXT",
    USER_INPUT_SINGLE_CHOICE: "USER_INPUT_SINGLE_CHOICE",
    USER_INPUT_MULTI_CHOICE: "USER_INPUT_MULTI_CHOICE",
    USER_INPUT_DATE: "USER_INPUT_DATE",
    TELEGRAM_JOIN_CHANNEL: "TELEGRAM_JOIN_CHANNEL",
    SNAPSHOT_JOIN_SPACE: "SNAPSHOT_JOIN_SPACE",
    SNAPSHOT_VOTE_PROPOSAL: "SNAPSHOT_VOTE_PROPOSAL",
    INSTAGRAM_FOLLOW_ACCOUNT: "INSTAGRAM_FOLLOW_ACCOUNT",
    INSTAGRAM_LIKE_POST: "INSTAGRAM_LIKE_POST",
    INSTAGRAM_COMMENT_POST: "INSTAGRAM_COMMENT_POST",
    MEDIUM_FOLLOW_ACCOUNT: "MEDIUM_FOLLOW_ACCOUNT",
    MEDIUM_LIKE_POST: "MEDIUM_LIKE_POST",
    FACEBOOK_FOLLOW_PAGE: "FACEBOOK_FOLLOW_PAGE",
    LINKEDIN_FOLLOW_PAGE: "LINKEDIN_FOLLOW_PAGE",
};
exports.EligibilityCriteriaSource = {
    USER_INPUT: "USER_INPUT",
    USER_EVENT: "USER_EVENT",
    LINK: "LINK",
    DISCORD: "DISCORD",
    TWITTER: "TWITTER",
};
exports.QuestRewardTypeConst = {
    REWARD_BADGE: "REWARD_BADGE",
    REWARD_XP: "REWARD_XP",
    REWARD_SKILL_SCORE: "REWARD_SKILL_SCORE",
    REWARD_GEMS: "REWARD_GEMS",
    REWARD_COLLECTIBLES: "REWARD_COLLECTIBLES",
    REWARD_DISCORD_ROLE: "REWARD_DISCORD_ROLE",
    REWARD_TOKEN: "REWARD_TOKEN",
    REWARD_CREDIT: "REWARD_CREDIT",
    UNDEFINED_RECORD: "UNDEFINED_RECORD",
};
exports.EntityTokenRecordTypeConst = {
    DISCORD: "DISCORD",
    GOOGLE: "GOOGLE",
    INSTAGRAM: "INSTAGRAM",
    OPENAI: "OPENAI",
    RAPID_API: "RAPID_API",
    STRIPE: "STRIPE",
    TELEGRAM: "TELEGRAM",
    TWITTER: "TWITTER",
};
exports.EligibilityCriteriaFrequencyConst = {
    DAILY: "DAILY",
    MONTHLY: "MONTHLY",
    ONCE: "ONCE",
    WEEKLY: "WEEKLY",
};
